import { ApiError, API_BASE_URL, getAccessToken } from './client'
import { formatUnitLabel } from '../utils/formatUnitLabel'

export type OrderBlankLineRequest = {
  catalogItemId: number
  quantity: number
  unit?: string
  unitPrice?: number
  note?: string
}

export const parseCartUnitPrice = (price: string | null | undefined): number | undefined => {
  if (price == null || price.trim() === '' || price.trim() === '—') {
    return undefined
  }
  const normalized = Number(price.trim().replace(',', '.'))
  return Number.isFinite(normalized) ? normalized : undefined
}

export type OrderBlankRequest = {
  organizationId: number
  privateSupplierId: number
  deliveryAddress?: string
  desiredDeliveryDate?: string
  desiredDeliveryTimeUntil?: string
  comment?: string
  lines: OrderBlankLineRequest[]
}

const ORDER_BLANK_PROMO = '\n\n📦 Заказ собран в Провизиуме · provisium.ru'

const orderBlankBody = (request: OrderBlankRequest) => ({
  organization_id: request.organizationId,
  private_supplier_id: request.privateSupplierId,
  delivery_address: request.deliveryAddress ?? null,
  desired_delivery_date: request.desiredDeliveryDate ?? null,
  desired_delivery_time_until: request.desiredDeliveryTimeUntil ?? null,
  comment: request.comment ?? null,
  lines: request.lines.map((line) => ({
    catalog_item_id: line.catalogItemId,
    quantity: line.quantity,
    unit: formatUnitLabel(line.unit),
    ...(line.unitPrice != null ? { unit_price: line.unitPrice } : {}),
    ...(line.note?.trim() ? { note: line.note.trim() } : {}),
  })),
})

export const appendOrderBlankPromo = (text: string): string => {
  if (text.includes('provisium.ru')) {
    return text
  }
  return `${text}${ORDER_BLANK_PROMO}`
}

export const fetchOrderBlankText = async (request: OrderBlankRequest): Promise<string> => {
  const token = getAccessToken()
  const response = await fetch(`${API_BASE_URL}/buyer/cart/order-blank?format=text`, {
    method: 'POST',
    headers: {
      Accept: 'text/plain;charset=UTF-8',
      'Content-Type': 'application/json;charset=UTF-8',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(orderBlankBody(request)),
  })
  if (!response.ok) {
    const text = await response.text().catch(() => '')
    throw new ApiError(response.status, text || response.statusText)
  }
  const bytes = await response.arrayBuffer()
  return new TextDecoder('utf-8').decode(bytes)
}
